const developmentEnv:string = 'development';
const productionEnv:string  = 'production';

export function features({ BOOM_ENV }: {
  BOOM_ENV?: string;
}) {
  const enabled = ({
    auth: {
      azure:      ()  => BOOM_ENV !== developmentEnv,
      credentials:()  => BOOM_ENV !== developmentEnv,
    },
    hud: {
      clear:      ()  => BOOM_ENV !== productionEnv,
      reload:     ()  => BOOM_ENV !== productionEnv,
      testingTags:()  => BOOM_ENV !== productionEnv,
      stages:     ()  => BOOM_ENV !== productionEnv,
      user: {
        new: {
          delete: ()  => BOOM_ENV === developmentEnv,
        }
      }
    },
    healthCheck:
    {
      commands:   ()  => BOOM_ENV !== productionEnv,
    }
  });

  return {
    ...enabled
  }
}
